const productionEndpoint = 'https://api.gokaizen.com';
const stagingEndpoint =
  'https://kz-staging-api-asia-east1-qpkgja3rxa-de.a.run.app';
const localEndpoint = 'http://localhost:8080';

let apiroot = productionEndpoint;
if (window.location.hostname.includes('kztesting.com') || 
  window.location.hostname.includes('kz-internal-staging')) {
  // Use staging API in testing site
  apiroot = stagingEndpoint;
}
if (window.location.hostname == 'localhost' && (window.webpackHotUpdate || window.webpackHotUpdatekz_internal_vue)) {
  // Use staging API when testing locally
  apiroot = stagingEndpoint;
  // Uncomment below to test API locally
  // apiroot = localEndpoint;
}

function getHeaders() {
  const headers = {};
  if (localStorage.id_token) {
    headers.Authorization = `Bearer ${localStorage.id_token}`;
  }
  headers['Content-Type'] = 'application/json';
  headers['Accept-Language'] = localStorage.language || 'en';
  return headers;
}

function handleGet(path, qs) {
  const url = new URL(apiroot + path);
  qs = qs || {};
  Object.keys(qs).forEach((key) => {
    url.searchParams.append(key, qs[key]);
  });
  return fetch(url, {
    method: 'GET',
    cors: 'cors',
    headers: getHeaders(),
  }).then(handleRes);
}

function handlePost(path, body) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'POST',
    cors: 'cors',
    headers: getHeaders(),
    body: JSON.stringify(body),
  }).then(handleRes);
}

function handlePut(path, body) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'PUT',
    cors: 'cors',
    headers: getHeaders(),
    body: JSON.stringify(body),
  }).then(handleRes);
}

function handleDelete(path) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'DELETE',
    cors: 'cors',
    headers: getHeaders(),
  }).then(handleRes);
}

function handleRes(r) {
  return new Promise((resolve, reject) => {
    r.json().then((data) => {
      if (r.status !== 200) {
        reject(data || r.statusText);
      } else {
        resolve(data);
      }
    });
  });
}

export default {
  get: handleGet,
  post: handlePost,
  put: handlePut,
  delete: handleDelete,
};
